module.exports = __webpack_public_path__ + "img/ro.23e5c37a.svg";